var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimesheetList',{attrs:{"additional-filters":{ booking_id: _vm.currentBookingId },"show-columns":['worker']}})
}
var staticRenderFns = []

export { render, staticRenderFns }